export const Src = {
  AllAma: 'AllAma',
  OwnAma: 'OwnAma',
  OwnCEE: 'OwnCEE'
};
export const SplitTreatment = {
  AI_best_match: 'AI_best_match',
  AI_pros_cons: 'AI_pros_cons'
};
export const HotelReviewInsightsItem = {
  family_friendly: 'family_friendly',
  exceptional_food: 'exceptional_food',
  relaxing_atmosphere: 'relaxing_atmosphere',
  good_location: 'good_location',
  excellent_cleanliness: 'excellent_cleanliness',
  amazing_for_couples: 'amazing_for_couples',
  fantastic_views: 'fantastic_views',
  for_beach_lovers: 'for_beach_lovers',
  nightlife: 'nightlife',
  accessible_rooms: 'accessible_rooms'
};
export const Brand = {
  AIDU: 'AIDU',
  inviacz: 'invia.cz',
  inviask: 'invia.sk',
  inviahu: 'invia.hu',
  travelplanetpl: 'travelplanet.pl'
};
export const Language = {
  en: 'en',
  de: 'de',
  cs: 'cs',
  sk: 'sk',
  pl: 'pl',
  hu: 'hu'
};
export const ModerationStatus = {
  approved: 'approved',
  rejected: 'rejected',
  pending: 'pending'
};
export const TextModerationStatus = {
  approved: 'approved',
  rejected: 'rejected',
  pending: 'pending',
  modified: 'modified'
};
export const PhotoCommonVisibility = {
  none: 'none',
  review: 'review',
  hotel: 'hotel'
};
export const PhotoCommonModerationStatus = {
  in_queue: 'in_queue',
  approved: 'approved',
  rejected: 'rejected',
  deleted: 'deleted'
};
export const TraveledAs = {
  couple: 'couple',
  single: 'single',
  family: 'family',
  friends: 'friends'
};
export const TravelType = {
  bathing: 'bathing',
  business: 'business',
  city: 'city',
  ski: 'ski',
  wellness: 'wellness',
  other: 'other'
};
export const ReviewCompetition = {
  review_winner: 'review_winner',
  review_laureate: 'review_laureate'
};
export const UserCommonUserIdSource = {
  amadeus: 'amadeus',
  cee: 'cee'
};
export const UserCommonSalutation = {
  Mr: 'Mr',
  Mrs: 'Mrs'
};
export const LanguageParamParameter = {
  en: 'en',
  de: 'de',
  cs: 'cs',
  sk: 'sk',
  pl: 'pl',
  hu: 'hu'
};
export const SrcParamParameter = {
  AllAma: 'AllAma',
  OwnAma: 'OwnAma',
  OwnCEE: 'OwnCEE'
};
export const ListReviewsSort = {
  latest: 'latest'
};
export const GetHotelReviewsSort = {
  latest: 'latest',
  oldest: 'oldest',
  ageAsc: 'ageAsc',
  ageDesc: 'ageDesc',
  ratingAsc: 'ratingAsc',
  ratingDesc: 'ratingDesc',
  travelTime: 'travelTime'
};